import { render, staticRenderFns } from "./ResetButton.vue?vue&type=template&id=c5c8afd8"
import script from "./ResetButton.vue?vue&type=script&lang=js"
export * from "./ResetButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports